document.addEventListener('DOMContentLoaded', function() {
  /**
   * PLP Badge Update Script — sale badges disabled
   *
   * Maintains dynamic sold-out, preorder, low-stock, custom, and new badges
   * when product-card swatches are hovered or selected. Percentage-off sale
   * badges are removed from the page and are never created by this script.
   *
   * data-color-badge values set by card-color-swatch.liquid:
   *   'sold-out'   → show sold-out badge  (.sold-out-badge.badge)
   *   'Preorder'   → skip — theme renders preorder badge independently
   *   '5 LEFT' etc → show low-stock badge (.custom-badge.badge)
   *   'BEST SELLER'→ show custom badge    (.custom-badge.badge)
   *   '-20%' etc   → remove sale badge; show no replacement badge
   *   'New'        → show new badge       (.custom-badge.badge)
   *   ''           → no badge — hide all visible badges
   */

  var PREORDER_BADGES = ['preorder', 'pre-order'];
  var SALE_BADGE_SELECTOR = '.sale-badge.badge';

  function isPreorderBadge(text) {
    var lower = (text || '').trim().toLowerCase();

    for (var i = 0; i < PREORDER_BADGES.length; i++) {
      if (lower === PREORDER_BADGES[i]) return true;
    }

    return false;
  }

  function isSoldOutBadge(text) {
    var lower = (text || '').trim().toLowerCase();
    return lower === 'sold-out' || lower === 'sold out';
  }

  // Detect a percentage-off sale value, such as "-20%".
  function isSaleBadge(text) {
    return /^-\d+%$/.test((text || '').trim());
  }

  /**
   * Remove every sale badge within a scope. This also removes badges rendered
   * by Liquid, so existing and dynamically loaded product cards stay clear of
   * percentage-off badges.
   */
  function removeSaleBadges(scope) {
    if (!scope) return;

    if (scope.matches && scope.matches(SALE_BADGE_SELECTOR)) {
      scope.remove();
      return;
    }

    if (scope.querySelectorAll) {
      scope.querySelectorAll(SALE_BADGE_SELECTOR).forEach(function(badge) {
        badge.remove();
      });
    }
  }

  /**
   * Update the non-sale badge in the card image wrapper from the swatch's
   * data-color-badge value.
   */
  function setBadge(card, badgeText) {
    var wrapper = card.querySelector('.grid-view-item-image');
    if (!wrapper) return;

    var badgeTrimmed = (badgeText || '').trim();

    // Sale badges are disabled globally. Do not create a replacement badge.
    if (isSaleBadge(badgeTrimmed)) {
      removeSaleBadges(wrapper);
      return;
    }

    // Skip preorder badges — the theme renders these independently.
    if (isPreorderBadge(badgeTrimmed)) return;

    if (isSoldOutBadge(badgeTrimmed)) {
      showSoldOutBadge(wrapper);
    } else if (badgeTrimmed) {
      // Show text badge (low-stock "X LEFT", custom tag, or "New").
      showTextBadge(wrapper, badgeTrimmed);
    } else {
      // No badge for this colour — hide all visible non-preorder badges.
      hideAllBadges(wrapper);
    }
  }

  function showSoldOutBadge(wrapper) {
    hideBadgeType(wrapper, '.custom-badge.badge');
    removeSaleBadges(wrapper);

    var soldOutBadge = wrapper.querySelector('.sold-out-badge.badge');
    if (soldOutBadge) {
      soldOutBadge.style.display = '';
    } else {
      var badge = document.createElement('div');
      badge.className = 'sold-out-badge badge';
      badge.setAttribute('data-injected-badge', 'true');
      badge.textContent = 'Sold out';
      wrapper.insertBefore(badge, wrapper.firstChild);
    }
  }

  function showTextBadge(wrapper, text) {
    hideBadgeType(wrapper, '.sold-out-badge.badge');
    removeSaleBadges(wrapper);

    var badge = wrapper.querySelector('.custom-badge.badge');
    if (badge) {
      badge.textContent = text;
      badge.style.display = '';
    } else {
      badge = document.createElement('div');
      badge.className = 'custom-badge badge';
      badge.setAttribute('data-injected-badge', 'true');
      badge.textContent = text;
      wrapper.insertBefore(badge, wrapper.firstChild);
    }
  }

  function hideAllBadges(wrapper) {
    hideBadgeType(wrapper, '.custom-badge.badge');
    hideBadgeType(wrapper, '.sold-out-badge.badge');
    removeSaleBadges(wrapper);
  }

  function hideBadgeType(wrapper, selector) {
    var badge = wrapper.querySelector(selector);
    if (badge) badge.style.display = 'none';
  }

  function getActiveSwatch(card) {
    // Each card in a combined listing owns its own .active swatch. Its
    // data-color-badge is the sole source for that card's current badge.
    return card.querySelector('.card-color-swatch--inner.active') ||
      card.querySelector('.card-color-swatch--inner');
  }

  function restoreBadge(card) {
    var active = getActiveSwatch(card);
    if (!active) return;

    var badgeText = (active.dataset.colorBadge || '').trim();
    setBadge(card, badgeText);
  }

  function scheduleBadgeRestore(card) {
    // Theme swatch scripts can apply several classes/attributes in one task.
    // Coalescing those mutations prevents a transient state from winning.
    if (card._badgeRestoreTimer) {
      window.clearTimeout(card._badgeRestoreTimer);
    }

    card._badgeRestoreTimer = window.setTimeout(function() {
      card._badgeRestoreTimer = null;
      restoreBadge(card);
    }, 0);
  }

  function initializeBadge(card) {
    // Render once immediately, then again after the theme has completed its
    // card/swatches setup. This makes every card independently pick the badge
    // for its own active swatch on first load.
    restoreBadge(card);

    var renderAfterThemeSetup = function() {
      if (card.isConnected) scheduleBadgeRestore(card);
    };

    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(function() {
        window.requestAnimationFrame(renderAfterThemeSetup);
      });
    } else {
      window.setTimeout(renderAfterThemeSetup, 0);
    }
  }

  function attachListeners(card) {
    if (card.getAttribute('data-badge-listeners-attached')) return;

    var swatches = card.querySelectorAll('.card-color-swatch--inner');
    if (!swatches.length) return;

    card.setAttribute('data-badge-listeners-attached', 'true');

    swatches.forEach(function(swatch) {
      // Mouseover: preview badge for this colour.
      swatch.addEventListener('mouseover', function() {
        var badgeText = (this.dataset.colorBadge || '').trim();
        setBadge(card, badgeText);
      });

      // Mouseleave on swatch: restore the active colour's badge.
      swatch.addEventListener('mouseleave', function() {
        restoreBadge(card);
      });

      // Click: lock badge to this colour (theme JS updates the active class).
      swatch.addEventListener('click', function() {
        var badgeText = (this.dataset.colorBadge || '').trim();
        setBadge(card, badgeText);
      });
    });

    // Restore on card mouseleave as a safety net.
    card.addEventListener('mouseleave', function() {
      restoreBadge(card);
    });

    // Render the selected swatch's non-sale badge immediately. This makes
    // sold-out, low-stock, custom, and new badges visible on first load,
    // rather than waiting for a swatch hover or click.
    initializeBadge(card);
  }

  // Remove Liquid-rendered sale badges already present on the page.
  removeSaleBadges(document);

  // Attach listeners to all cards present on page load.
  document.querySelectorAll('product-card').forEach(attachListeners);

  // Remove sale badges and initialize cards added by infinite scroll, filters,
  // quick views, or other dynamic rendering.
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes') {
        var attributeCard = mutation.target.closest &&
          mutation.target.closest('product-card');
        if (attributeCard) scheduleBadgeRestore(attributeCard);
        return;
      }

      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType !== 1) return;

        removeSaleBadges(node);

        // A product-card can be inserted before its swatches are rendered.
        // Re-check its parent as swatch markup arrives.
        var parentCard = node.closest && node.closest('product-card');
        if (parentCard) attachListeners(parentCard);

        if (node.tagName && node.tagName.toLowerCase() === 'product-card') {
          attachListeners(node);
        }

        if (node.querySelectorAll) {
          node.querySelectorAll('product-card').forEach(attachListeners);
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'data-color-badge']
  });
});
